import script from "./promotion.vue?vue&type=script&setup=true&lang=js"
export * from "./promotion.vue?vue&type=script&setup=true&lang=js"

import "./promotion.vue?vue&type=style&index=0&id=452daf06&scoped=true&lang=less"

import exportComponent from "C:\\Users\\86183\\Desktop\\yw-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-452daf06"]])

export default __exports__